import React from 'react';
import { Link } from 'react-router-dom';

const services = [
    {
        id: 'modular-kitchen',
        title: 'Modular Kitchen',
        desc: 'Custom-built modular kitchens with premium finishes, smart storage, and ergonomic design tailored to your lifestyle.',
        image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&q=80',
    },
    {
        id: 'living-room',
        title: 'Living Room Design',
        desc: 'Transform your living space with bespoke TV units, wall panels, and furniture that reflect your personality.',
        image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600&q=80',
    },
    {
        id: 'bedroom-design',
        title: 'Bedroom Interiors',
        desc: 'Luxurious bedroom designs with wardrobes, dressers, and serene color palettes for the perfect retreat.',
        image: 'https://images.unsplash.com/photo-1540518614846-7eded433c457?w=600&q=80',
    },
    {
        id: 'interior-design',
        title: 'False Ceiling Design',
        desc: 'Stunning false ceilings with ambient lighting, gypsum work, and modern patterns for every room.',
        image: '/images/False Ceiling Design.jpg',
    },
    {
        id: 'interior-design',
        title: 'Bathroom Design',
        desc: 'Spa-inspired bathroom interiors with premium tiles, vanity units, and elegant fixtures.',
        image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=600&q=80',
    },
    {
        id: 'interior-design',
        title: 'Pooja & Foyer Design',
        desc: 'Sacred Pooja units and grand foyer designs that create the perfect first impression of your home.',
        image: '/images/Pooja & Foyer Design.jpg',
    },
];

export default function ServicesSection() {
    return (
        <section className="section-pad bg-white" id="services">
            <div className="max-w-7xl mx-auto px-4">
                {/* Heading */}
                <div className="text-center mb-12">
                    <p className="text-[#2E63E8] font-semibold uppercase tracking-widest text-sm mb-2">What We Offer</p>
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Services</h2>
                    <div className="w-20 h-1 bg-[#2E63E8] mx-auto rounded-full"></div>
                </div>

                {/* Grid */}
                <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8">
                    {services.map((service, i) => (
                        <div key={i} className="card-hover rounded-2xl overflow-hidden shadow-md bg-white border border-gray-100 flex flex-col">
                            {/* Image */}
                            <Link to={`/services?id=${service.id}`} className="h-32 md:h-56 overflow-hidden block">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                                />
                            </Link>
                            {/* Content */}
                            <div className="bg-[#0D0D0D] p-3 md:p-6 flex-1 flex flex-col justify-between">
                                <Link to={`/services?id=${service.id}`} className="block group/text">
                                    <h3 className="text-white text-base md:text-xl font-bold mb-1 md:mb-2 group-hover/text:text-[#2E63E8] transition-colors">{service.title}</h3>
                                    <p className="text-gray-400 text-[11px] md:text-sm leading-relaxed mb-3 md:mb-4 line-clamp-3">
                                        {service.desc}
                                    </p>
                                </Link>
                                <Link to={`/services?id=${service.id}`} className="inline-flex items-center text-[#2E63E8] text-[11px] md:text-sm font-semibold hover:gap-2 transition-all group mt-auto">
                                    Read More
                                    <span className="ml-0.5 group-hover:ml-1.5 transition-all">→</span>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
